'use client'

import { ThemeProvider } from 'next-themes'
import { PropsWithChildren } from 'react'

export const UIProvider = ({ children }: PropsWithChildren) => {
  return (
    <ThemeProvider attribute={'class'} defaultTheme={'light'} themes={['light', 'dark']}>
      {children}
    </ThemeProvider>
  )
}
